import { render, staticRenderFns } from "./CustomerCredit.vue?vue&type=template&id=68dfb536&scoped=true&"
import script from "./CustomerCredit.vue?vue&type=script&lang=js&"
export * from "./CustomerCredit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCredit.vue?vue&type=style&index=0&id=68dfb536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfb536",
  null
  
)

export default component.exports